import { isAnyOf } from '@reduxjs/toolkit';

import ooeConstants from '../constants';
import { actions as deviceActions } from '../device/reducer';
import { AppStartListening } from '../listenerMiddleware';
import ReduxStore from '../util/reduxStore';

window.addEventListener('online', () => {
  ReduxStore.dispatch(deviceActions.deviceOnline());
});
window.addEventListener('offline', () => {
  ReduxStore.dispatch(deviceActions.deviceOffline());
});

const addDeviceListeners = (startListening: AppStartListening) => {
  startListening({
    matcher: isAnyOf(deviceActions.deviceOffline, deviceActions.deviceOnline),
    effect: async (action, listenerApi) => {
      const { dispatch, cancelActiveListeners, delay, extra } = listenerApi;

      // debounce (https://redux-toolkit.js.org/api/createListenerMiddleware#complex-async-workflows)
      cancelActiveListeners();
      await delay(ooeConstants.ONLINE_MESSAGE_TIMEOUT);

      if (extra.testUtils?.debounceCallback) {
        extra.testUtils.debounceCallback(action);
      }

      if (action.type === deviceActions.deviceOnline.type) {
        dispatch(deviceActions.hideMessage());
      }
    },
  });
};

export default addDeviceListeners;
